export { Tabs } from "./tabs";
export { TabsList, TabsTab } from "./tabs-list";
export { TabsContents, TabsContent } from "./tabs-content";

export type * from "./tabs";
export type * from "./tabs-list";
export type * from "./tabs-content";
